import React, { createContext, MutableRefObject, useRef } from "react";

interface PageScaffoldContextProps {
  contentRef: MutableRefObject<HTMLDivElement | null>;
}

const PageScaffoldContext = createContext<PageScaffoldContextProps | null>(null);

export const PageScaffoldProvider: React.FC<React.PropsWithChildren> = ({ children }) => {
  const contentRef = useRef<HTMLDivElement | null>(null);

  return (
    <PageScaffoldContext.Provider
      value={{
        contentRef,
      }}
    >
      {children}
    </PageScaffoldContext.Provider>
  );
};

export default PageScaffoldContext;
